import { render, staticRenderFns } from "./budget-resultunit.vue?vue&type=template&id=39021315&scoped=true"
import script from "./budget-resultunit.vue?vue&type=script&lang=js"
export * from "./budget-resultunit.vue?vue&type=script&lang=js"
import style0 from "./budget-resultunit.vue?vue&type=style&index=0&id=39021315&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39021315",
  null
  
)

export default component.exports